export default {
  club_name: 'Stockholm Open',
  club_name_short: 'stockholmopen',
  stadium_name: '',
  staging_url: 'https://stockholmopen.api.fangroup.io',
  prod_url: 'https://stockholmopen.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/stockholmopen',
  club_logo: '/assets/teams/stockholmopen.png',
  app_name: 'stockholmopen',
  websale_name: 'stockholmopen',
  ntb_team_id: 10076,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'stockholmopen',
  monolithEnabled: false,
  clubWebsiteEnabled: true,
};
